export default "__VITE_ASSET__D3A5EOeJ__"